import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, InputAdornment, InputLabel, MenuItem, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { api } from '../../../redux/api';
import TabPanel from '../../TabPanel';
import { t } from "i18next";
import { convertCaseOptionsArray, errorArray, fieldTypeOptionsArray, onErrorDropDown, paddingDirectionArray } from '../../../constants/constantList';
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DatePattern from '../PatternModal/DatePattern';
import NumberFormatter from '../PatternModal/NumberFormatter';
import Tree from 'rc-tree';
import { treeActions } from '../../../redux/slices/treeSlice';
import { lgDocPath } from '../../../constants/languageDocPaths';
import { DialogActions } from '@mui/material';
import { cloneDeep, debounce, isDate } from 'lodash';
import { eachDeep } from "deepdash-es/standalone";
import ReplacementModal from './Advanced Properties/ReplacementModal';
import SourceType from '../../TemplateProperties/SourceType';
import { ConstantValueControl } from './OutboundFieldFormattingOptions/ConstantValueControl';
import { SectionHeader } from './SectionHeader';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StandaloneDatePicker from '../DatePicker';
import LabeledCheckbox from '../../TemplateProperties/TPCheckbox';
import FormattingOptionsCheckboxes from './FormattingOptionsCheckboxes';
import AdvancedProperties from './Advanced Properties/AdvancedProperties';
import { customDecoding, validateWorkflowItemName, scrollToSelectedItem } from '../../../utils/utilFunctions';
import WorkflowSourceType from '../../../commonComponents/WorkflowSourceTypeComponent/WorkflowSourceType';
import ErrorModal from './FieldDataValidation/ErrorModal';

function PluginProperties() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree, leftTree, templateChanged, templateChangedSource } = useSelector((state) => state.treeData[parentScreen]);
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const { account } = useSelector((state) => state.queryParams);
    const queryParams = useSelector((state) => state.queryParams);
    const selectedNode = useSelector((state) => state.treeData[parentScreen].rightTree.tree?.[rightTree.currentTab]?.selectedNode);
    const docPaths = {
        DATE: `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/DateFormatter.html`,
        NumberFormatter: `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/NumberFormatter.html`
    };
    const [pluginsDropdown, setPluginsDropdown] = useState();
    const [pluginName, setPluginName] = useState("");
    const [currTab, setCurrTab] = useState(0);
    const [fieldTypeOptions, setFieldTypeOptions] = useState();
    const [fieldTypeDropDownItems, setFieldTypeDropDownItems] = useState();
    const [convertCaseOptions, setConvertCaseOptions] = useState();
    const [convertCaseDropdown, setConvertCaseDropdown] = useState();
    const [paddingDirectionOptions, setPaddingDirectionOptions] = useState();
    const [paddingDirectionDropdown, setPaddingDirectionDropdown] = useState();
    const [errorOptions, setErrorOptions] = useState();
    const [errorDropdown, setErrorDropdown] = useState();
    const [isDateMapped, setIsDateMapped] = useState(false);
    const [inboundPattern, setInboundPattern] = useState();
    const [constantValueOptions, setConstantValueOptions] = useState();
    const [treeData, setTreeData] = useState({ in: [], out: [] });
    const [plugin, setPlugin] = useState('');
    const [fieldType, setFieldType] = useState();
    const [length, setLength] = useState(0);
    const [convertCase, setConverCase] = useState();
    const [paddingDirection, setPaddingDirection] = useState();
    const [error, setError] = useState();
    const [ignoreSubs, setIgnoreSubs] = useState(false);
    const [fillCharacter, setFillCharacter] = useState('');
    const [defaultValue, setDefaultValue] = useState('');
    const [date, setDate] = useState('');
    const [inboundDate, setInboundDate] = useState('');
    const [datePatternModal, setDatePatternModal] = useState(false);
    const [inboundDatePatternModal, setInboundDatePatternModal] = useState(false);
    const [inboundDatePattern, setInboundDatePattern] = useState('');
    const [datePattern, setDatePattern] = useState('');
    const [numberFormatterModal, setNumberFormatterModal] = useState(false);
    const [numberPattern, setNumberPattern] = useState('');
    const [valid, setValid] = useState(true);
    const [dpNetworkCallMessage, setDpNetworkCallMessage] = useState('');
    const [flag, setFlag] = useState(false);
    const [inboundPrecision, setInboundPrecision] = useState(0);
    const [outboundPrecision, setOutboundPrecision] = useState(0);
    const [constant, setConstant] = useState();
    const [repeat, setRepeat] = useState(1);
    const [expandedKeys, setExpandedKeys] = useState({ in: [], out: [] });
    const [selectedKeys, setSelectedKeys] = useState({ in: [], out: [] });
    const [pluginDescription, setPluginDescription] = useState('');
    const [pluginModal, setPluginModal] = useState(false);
    const [inValues, setInValues] = useState(null);
    const [currentNode, setCurrentNode] = useState(null);
    const [openDelimiterDialog, setDelimiterDialog] = useState(false);
    const [constantError, setConstantError] = useState("");
    const [loading, setLoading] = useState(false);
    const errorRef = useRef(null);
    const treeContainerRef = useRef(null);
    const [detailLoading, setDetailsLoading] = useState(false);
    const [doNotLog, setDoNotLog] = React.useState(false);
    const [disableWFItem, setDisableWFItem] = React.useState(false);
    const [concurrent, setConcurrent] = React.useState(false);
    const [bitPosition, setBitPosition] = useState("1");
    const [bitValue, setBitValue] = useState("0");
    const [nameErrorModal, setNameErrorModal] = useState(false);
    const [nameErrorMessage, setNameErrorMessage] = useState('');
    const wfItemId = selectedNode?.ID;

    const handleNameBlur = (eVal) => {
        if (parentScreen !== "workflow") {
            setPluginName(selectedNode?.NAME);
            setTimeout(() => {
                dispatch(treeActions.setIsInputFocusedFalse());
            }, 100);
            return;
        }
        
        const oldName = selectedNode?.NAME || '';
        
        const validationResult = validateWorkflowItemName(
            eVal, 
            oldName, 
            translatedData, 
            selectedNode?.key, 
            'PLUGIN_ITEM'
        );
        
        if (validationResult.isValid) {
            const newName = eVal?.trim() || '';
            setPluginName(newName);
            if (newName !== oldName) {
                // Mark template as changed immediately to ensure flag is set before tab switch
                dispatch(treeActions.setTemplateChanged({ screen: parentScreen, data: true }));
                submitChange("NAME", newName);
                // Wait for debounce delay + buffer before dispatching
                setTimeout(() => {
                    dispatch(treeActions.setIsInputFocusedFalse());
                }, 200);
            } else {
                // If no change, dispatch immediately
                setTimeout(() => {
                    dispatch(treeActions.setIsInputFocusedFalse());
                }, 100);
            }
        } else {
            if (validationResult.errorMessage) {
                setNameErrorMessage(t(validationResult.errorMessage));
                setNameErrorModal(true);
            } else if (validationResult.shouldRevert) {
                setPluginName(oldName);
            }
            // For error cases, dispatch immediately
            setTimeout(() => {
                dispatch(treeActions.setIsInputFocusedFalse());
            }, 100);
        }
    };

    const handleNameErrorModal = (isOpen) => {
        setNameErrorModal(isOpen);
        if (!isOpen) {
            const oldName = selectedNode?.NAME || '';
            setPluginName(oldName);
        }
    };

    const onErrorDropDownMenu = onErrorDropDown.map((e, i) => {
		return (
			<MenuItem key={"variableAction" + i} value={e.value}>
				{t(e.text)}
			</MenuItem>
		);
	});

    const bitValueDropdown = useMemo(
        () =>
            ["0", "1"].map((e, i) => (
                <MenuItem key={`bitValue-${i}`} value={e}>
                    {e}
                </MenuItem>
            )),
        []
    );

    const bitPositionDropdown = useMemo(
        () =>
            ["1", "2", "3", "4", "5", "6", "7", "8"].map((e, i) => (
                <MenuItem key={`bitPosition-${i}`} value={e}>
                    {e}
                </MenuItem>
            )),
        []
    );

    const filterInARG = (inArgs) => {
        const clonedArgs = cloneDeep(inArgs);
        const filteredArgs = clonedArgs.map(arg => {
            const validJSONKeys = ["ARGTYPE", "ARGNAME", "INARGWIDGETTYPE", "FIELDTYPE", "ICON_DISPLAY", "CALL_WORKFLOW", "CALL_WORKFLOW_ACCOUNT", "CALL_WORKFLOW_GROUP", "OUTBOUND", "WF_ITEM_ID", "WF_ITEM_LOCATION", ...(supportedJSONValuesForFieldTypes?.[arg?.FIELDTYPE] || [])];
            Object.keys(arg).forEach(key => {
                if (!validJSONKeys.includes(key)|| arg[key] === null || arg[key] === undefined) delete arg?.[key];
                else if (typeof arg[key] === "boolean") {
                    arg[key] = arg[key] ? "TRUE" : "FALSE";
                }
                if (key === "VALUE" && arg?.hasOwnProperty("VALUE")) {
                    arg[key] = (arg[key])
                    arg[key] = (arg[key])
                }
                if (key === "IGNORE_GLOBAL_SUB" && arg?.hasOwnProperty(key) && arg[key] === "FALSE") delete arg?.[key];
            })
            return arg;
        })
        return filteredArgs;
    }


    const submitChange = (key, val, valuesObj, _cb, avoidLoading) => {
        if (key !== "CLASS" && key !== "IN_ARG" && key !== 'OUT_ARG' && key !== 'ARGS' && key !== "NAME" && !Object.keys(valuesObj || {}).length
        && key !== "LOG_WFITEM_DETAILS" && key !== "CONCURRENT" && key !== "ENABLED") return;
        const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
            if (objValue?.key !== selectedNode.key) {
                return;
            }
            if (key === "CLASS") {
                objValue[key] = val;
                objValue['DESCRIPTION'] = val;
            } else if (key === 'ARGS') {
                objValue['IN_ARG'] = filterInARG(val.in);
                objValue['OUT_ARG'] = val.out;
            } else if (key === "IN_ARG") {
                objValue[key] = filterInARG(val);
            } else if (key === 'OUT_ARG') {
                objValue[key] = val;
            }
            else if (key === "NAME") {
                objValue[key] = val;
            }
            if (!key && Object.keys(valuesObj).length) {
                Object.keys(valuesObj).forEach(key => {
                    objValue[key] = key === "IN_ARG" ? filterInARG(valuesObj[key]) : valuesObj[key];
                })
            }
            else objValue[key] = val || selectedNode[key];
            const titleWf = objValue?.NAME || objValue?.CLASS || "";
            const titleOb = `${t("PLUGIN_")}${objValue?.CLASS ? ` ${objValue?.CLASS}` : ""}:${objValue?.NAME ? ` ${objValue?.NAME}` : objValue?.NAME === "" ? "" : " UNNAMED"}`;
            objValue['title'] = parentScreen === "outbound" ? titleOb : titleWf;
                if (!avoidLoading) { // to avoid multiple loading states when multiple changes are made in quick succession
                    dispatch(
                        treeActions.setRightTreeSelectedNode({
                            screen: parentScreen,
                            type: rightTree.currentTab,
                            data: objValue,
                        })
                    );
                
            }
        });
        if (!avoidLoading) { // to avoid multiple loading states when multiple changes are made in quick succession
            dispatch(
                treeActions.setNewRightTreeTranslatedData({
                    screen: parentScreen,
                    type: rightTree.currentTab,
                    data: updatedData,
                })
            )
        }
        if (_cb) _cb();
    };

    const debounceChangeHandler = useCallback(debounce(submitChange, 200), [
        rightTree.currentTab,
        rightTree.tree,
        selectedNode?.key,
        selectedNode
    ]);

    const handleCurrentNodeChange = (key, value, valuesObj, callPluginDetails, avoidLoading) => {
        
        let updatedArgs = [];
        let node;
        if (selectedNode && selectedNode?.IN_ARG && currentNode !== null) {
            const inArgs = [...selectedNode?.IN_ARG];
            if (inArgs?.length !== 0) {
                for (let i = 0; i < inArgs.length; i++) {
                    if (valuesObj?.title) {
                        if ((valuesObj?.title === inArgs[i].ARGNAME) || valuesObj?.ARGNAME === inArgs[i].ARGNAME) {
                            if (!key) {
                                node = { ...inArgs[i], ...valuesObj }
                            } else {
                                node = { ...inArgs[i], [key]: value }
                            }
                            getNodeValues(node);
                        } else node = inArgs[i];
                    }
                    else if ((currentNode?.title === inArgs[i].ARGNAME) || currentNode?.ARGNAME === inArgs[i].ARGNAME) {
                        if (!key) {
                            node = { ...inArgs[i], ...valuesObj,
                                ...(currentNode?.selectionList ? {selectionList: currentNode.selectionList} : {})
                             }
                        } else {
                            node = { ...inArgs[i], [key]: value }
                        }
                        getNodeValues(node);
                        setCurrentNode((prev) => {
                            return { ...prev, ...inArgs[i], ...valuesObj }
                        });
                    } else node = inArgs[i];
                    updatedArgs.push(node);
                }
            } else {
                if (selectedNode && currentNode !== null) updatedArgs.push({ ...currentNode, [key]: value });
            }
        }
        updatedArgs = filterInARG(updatedArgs);
        dataConversion("in", updatedArgs);
        if (callPluginDetails) getPluginDetail(plugin, null, false, false, updatedArgs, avoidLoading);
        debounceChangeHandler(
            'IN_ARG', 
            updatedArgs,
        )
    }

    const debounceCurrentNodeChangeHandler = useCallback(debounce(handleCurrentNodeChange, 800), [
        rightTree.currentTab,
        rightTree.tree,
        selectedNode?.key,
        selectedNode,
        currentNode,
    ]);

    const dataConversion = (type, values, immediate = false) => {
        const newValues = values && values?.map((value, index) => {
            if (typeof value === 'object') {
                
                return {
                    ...value,
                    key: `${type?.toLowerCase()}-${index}`,
                    title: value?.ARGNAME ? value?.ARGNAME : value?.MAPNAME ? value?.MAPNAME : value?.name,
                    FIELDTYPE: value?.FIELDTYPE ? value?.FIELDTYPE : 'PROPERTY',
                    FILLCHAR: (value?.FILLCHAR  || ''),
                    CONVERT_CASE: value?.CONVERT_CASE,
                    ARGTYPE: value?.ARGTYPE,
                    PADDIR: value?.PADDIR || 'RIGHT',
                    LENGTH: value?.LENGTH ? value?.LENGTH : 0,
                    INARGWIDGETTYPE: value?.INARGWIDGETTYPE,
                    RECORD_TYPE: value?.RECORD_TYPE,
                    SOURCE_TYPE: value?.SOURCE_TYPE,
                    MAPNAME: value?.MAPNAME,
                    PARENT: value?.PARENT,
                    VALUE: (value?.VALUE),
                    SELECTION_LIST: value?.SELECTION_LIST || [],
                    ...(value?.REPEAT ? {REPEAT: value?.REPEAT || 1} : {}),
                    IGNORE_GLOBAL_SUB : (value?.IGNORE_GLOBAL_SUB === "TRUE" || value?.IGNORE_GLOBAL_SUB === true) ? true : false,
                    BIT_POSITION: value?.BIT_POSITION || "1",
                }
            } else return {
                key: `${type?.toLowerCase()}-${index}`,
                title: value?.MAPNAME ? value?.MAPNAME : value,
            }
        });
        if (immediate && newValues?.length) {
            setSelectedKeys((prev) => {
                return { ...prev, [type]: [newValues[0].key] }
            });
            setCurrentNode(newValues[0]);
        }
        setTreeData((prev) => {
            return { ...prev, [type]: newValues };
        });
    }


    const getNewArgs = (currentArgs= [], previousArgs =[], updateSelectionListOnly) => {
        return currentArgs?.map(e => {
            const argName = typeof e === 'object' ? (e?.name || e?.ARGNAME) : e;
            const previousArg = cloneDeep(previousArgs.find((o) => {
                if (argName === o.ARGNAME) return true;
            }))
            if (previousArg) previousArg.selectionList = e?.selectionList || []
            if (updateSelectionListOnly) return previousArg ? previousArg : null;
            return previousArg ? previousArg : e;
        }).filter(e => e !== null);
    }

    const createInArgs = (type, inValues, previousArgs, initialCall, updateSelectionListOnly) => {
        const inArray = [];
        let node;
        const newArgs = getNewArgs(inValues, previousArgs, updateSelectionListOnly);
        for (let i = 0; i < newArgs?.length; i++) {
            const value = (!newArgs[i]?.VALUE && (["PROPERTY", "CONSTANT"].includes(newArgs?.[i]?.FIELDTYPE) || !newArgs?.[i]?.FIELDTYPE)) 
                            ? (newArgs?.[i]?.selectionList?.[0] || "") : (newArgs?.[i]?.VALUE || "");
            const repeat = (i === 0 && (["PROPERTY", "CONSTANT"].includes(newArgs?.[i]?.FIELDTYPE) || !newArgs?.[i]?.FIELDTYPE)) ? newArgs?.[i]?.REPEAT || null : newArgs?.[i]?.REPEAT || null
            if (typeof newArgs[i] === 'object') {
                node = {
                    ...newArgs[i],
                    ARGTYPE: type,
                    ARGNAME: newArgs?.[i]?.name || newArgs?.[i]?.ARGNAME,
                    FIELDTYPE: newArgs?.[i]?.FIELDTYPE || "PROPERTY",
                    REPEAT: repeat,
                    INARGWIDGETTYPE: "SELECT",
                    selectionList: newArgs?.[i]?.selectionList?.map(e => (e)) || [],
                    LENGTH: newArgs?.[i]?.LENGTH || null,
                    ICON_DISPLAY : "IN_ARG",
                    ...(value?.length ? {LENGTH: newArgs[i].ARGNAME === "Execute Date (yyyy/mm/dd)" ? "" :  (value?.length || 0) * (+newArgs?.[i]?.REPEAT || 1) , VALUE: value} : {})
                }
            } else {
                node = {
                    ARGTYPE: type,
                    ARGNAME: newArgs[i],
                    FIELDTYPE: 'PROPERTY',
                    LENGTH: "0",
                    INARGWIDGETTYPE: "SELECT",
                    ICON_DISPLAY : "IN_ARG",
                    selectionList: newArgs?.[i]?.selectionList?.map(e => (e)) || [],
                }
            }
            inArray.push(node);
        }
        dataConversion('in', inArray);
        return inArray;
    }

    const createOutArgs = (type, outValues, _name) => {
        const outArray = [];
        for (let i = 0; i < outValues?.length; i++) {
            let node = {
                "ARGTYPE" : "OUT", 
                "ICON_DISPLAY" : "OUT_ARG", 
                "MAPNAME" : outValues[i], 
                "PARENT" : "NONE", 
                "RECORD_TYPE" : "PLUGIN", 
                "SOURCE_TYPE" : "OUTBOUND_ITEM" 

            }
            outArray.push(node);
        }
        dataConversion('out', outArray);
        return outArray;
    }

    const advancePropertiesHandler = (obj) => {
		handleCurrentNodeChange(null, null , obj);
	}

    const mapping1Handler = (values, sourceType) => {
        const isDateMapped = values.FIELDTYPE === "DATE";
        setIsDateMapped(isDateMapped || ["TODAY", "TOMORROW", "YESTERDAY"].includes(values?.MAPNAME));
        setInboundDate(values?.PATTERN || currentNode?.INBOUND_PATTERN || '');
        const {PARENT, MAPNAME, RECORD_TYPE, ACTION, INDEX, MAP_REPETITION_INDEX, CUSTOM_DB_FIELD, PLUGIN_NAME, WF_ITEM_ID, WF_ITEM_LOCATION, CALL_WORKFLOW, CALL_WORKFLOW_ACCOUNT, CALL_WORKFLOW_GROUP, OUTBOUND_NAME: OUTBOUND, SOURCE_REPEATING_FIELD } = values;
		const newObj = {PARENT, MAPNAME, RECORD_TYPE, MAP_REPETITION_INDEX, CUSTOM_DB_FIELD ,PLUGIN_NAME, WF_ITEM_ID, WF_ITEM_LOCATION, VARIABLE_COLLECTION_ACTION: ACTION, VARIABLE_COLLECTION_INDEX: INDEX, isDateMapped, ...(values?.FIELDTYPE === "DATE" ? {INBOUND_PATTERN: values?.PATTERN} : {}), CALL_WORKFLOW, CALL_WORKFLOW_ACCOUNT, CALL_WORKFLOW_GROUP, OUTBOUND, SOURCE_REPEATING_FIELD, SOURCE_TYPE: sourceType }
        handleCurrentNodeChange(null, null, newObj, true);
    };

    const handleTabChange = (_event, newValue) => {
        setCurrTab(newValue);
        const nodeFromKey = selectedKeys?.[newValue ? "out" : "in"]?.[0]?.split("-")?.[1] || 0;
        
        if(newValue === 0){
            setCurrentNode(treeData["in"][nodeFromKey]);
            updateSelectionList(treeData["in"][nodeFromKey]?.selectionList || []);
        }
    };

    const datePatternModalCancelHandler = () => {
        setDatePatternModal(false);
    };

    const dateInboundPatternModalCancelHandler = () => {
        setInboundDatePatternModal(false);
    };

    const inboundDatePatternModalOkHandler = () => {
        setInboundDate(inboundDatePattern);
        setInboundDatePatternModal(!inboundDatePatternModal);
        handleCurrentNodeChange('INBOUND_PATTERN', inboundDatePattern);
    };

    const datePatternModalOkHandler = () => {
        setDate(datePattern);
        setDatePatternModal(!datePatternModal);
        handleCurrentNodeChange('PATTERN', datePattern);
    };

    const numberFormatterOkHandler = (valuesObj) => {
        setNumberPattern(valuesObj?.PATTERN || '');
        setDate(valuesObj?.PATTERN || '');
        setInboundPrecision(valuesObj?.PRECISION || 0);
        setNumberFormatterModal(false);
        handleCurrentNodeChange(null, null, {
            PATTERN: valuesObj?.PATTERN || null,
            PRECISION: valuesObj?.PRECISION || 0,
            ROUND: valuesObj?.ROUND
        });
    };

    const testDateHandler = (key, val) => {
        if (!val) {
            setDpNetworkCallMessage(t('BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN'))
            setValid(false)
        }
        if (val) {
            dispatch(
                api.endpoints.validateDatePattern.initiate({
                    datePattern: encodeURIComponent(val),
                })
            ).then((response) => {
                if (response) {
                    if (response.data.current_state === 'ERROR') {
                        setValid(false)
                        setFlag(false)
                        setDpNetworkCallMessage(response.data.message)

                    } else {
                        if (key === 'fromModal') {
                            setFlag(true)
                            setDpNetworkCallMessage(response.data.message)
                        }
                        setValid(true)
                    }
                }
            })
        }
    };

    const getPluginList = () => {
        setLoading(true); 
        errorRef.current.textContent = ""
        dispatch(
            api.endpoints.getPluginsList.initiate(
                { account }, 
                { forceRefetch: true }
            )
        )
        .then((response) => {
            if (response?.error) {
                throw new Error(response.error.data?.message || t('ERR_PLUGIN_LIST'));
            }
            const data = Object.entries(response?.data || {}).map((item) => ({
                key: item[0],
                value: item[1]
            }));

            if (data) {
                updatePluginsDropdown(data);
            }
        })
        .catch((err) => {
            if(errorRef?.current) errorRef.current.textContent = err.message
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const updatePluginsDropdown = (data) => {
        const pluginsDropdownList = data?.map((obj, key) => {
            return <MenuItem key={key} value={obj.value}>
                {obj.value}
            </MenuItem>
        })
        setPluginsDropdown(pluginsDropdownList)
    }

    const onExpand = (type, keys) => {
        setExpandedKeys((prev) => {
            return { ...prev, [type]: keys }
        });
    };

    const onSelect = (type, _keys, detail) => {
        
        if(detail?.node?.ARGNAME === currentNode?.ARGNAME)
            return;

        setSelectedKeys((prev) => {
            return { ...prev, [type]: [detail.node.key] }
        });
        if (type === "in") {
            const key = detail?.node?.title || '';
            const value = detail?.node?.VALUE?.length ? {VALUE: detail.node.VALUE} : detail.node.selectionList?.length ? {VALUE: detail.node.selectionList?.[0], REPEAT: 1} : {};
            setCurrentNode({...detail.node, ...value});
            handleCurrentNodeChange(null, null, {...detail.node, ...value}, true, true);
            updateSelectionList(detail.node.selectionList);
        }
    };

    const updateSelectionList = (list= []) => {
        setConstantValueOptions(list.map(item => customDecoding(item)));
    }

    const getNodeValues = (node) => {
        setConstantError("");
        setFieldType(node?.FIELDTYPE === "PROPERTY" ? "CONSTANT" : node?.FIELDTYPE || t("SELECT"));
        setRepeat(node?.REPEAT || "1");
        if (node?.FIELDTYPE === 'CONSTANT' || node?.FIELDTYPE === "PROPERTY") setLength((node?.VALUE || "")?.length * Number(node?.REPEAT || 1));
        else setLength(node?.LENGTH || 0);
        setConstant((node?.VALUE) || '');
        setConverCase(node?.CONVERT_CASE || 'DO_NOT_CONVERT');
        setPaddingDirection(node?.PADDIR || "RIGHT");
        setFillCharacter(node?.FILLCHAR === " " ? "SPACE" : node?.FILLCHAR || '');
        setInboundPrecision(node?.PRECISION || 0);
        setOutboundPrecision(node?.PRECISION_OUT || 0);
        setError(node?.KEEP_ORIG_DATA_ON_ERROR);
        setDefaultValue(node?.DEFAULT_VALUE);
        setInboundDatePattern(node?.INBOUND_PATTERN || "");
        setInboundDate(node?.INBOUND_PATTERN || "");
        setDatePattern(node?.PATTERN || "");
        setDate(node?.PATTERN || "");
        setNumberPattern(node?.PATTERN || "");
        setIgnoreSubs((node?.IGNORE_GLOBAL_SUB === "TRUE" || node?.IGNORE_GLOBAL_SUB === true) ? true : false)
        setBitPosition(node?.BIT_POSITION || "1");
        setBitValue(node?.VALUE || "0");
        
    }

    const Icon = () => {
        return <span className={'tree-icon ' + 'PLUGIN'}></span>
    }

    const titleRender = (node) => {
        return <span data-key={`${node?.key}`}>{node.title}</span>;
    }

    const handleDelimiterDialogValue = (val) => {
        setConstant(val);
        handleCurrentNodeChange('VALUE', val);
    }

    const handleDelimiterDialog = (val) => {
        if (val === '') setConstant('');
        else {
            setConstant(val);
            handleCurrentNodeChange('VALUE', val);
        }
        setDelimiterDialog(false);
    }


    const getBodyForPluginDetails = (latestData) => {
        const body = {
            inboundarguments : {}
        }
        latestData.forEach((arg) => {
            const argObj = {
                value: (arg.VALUE) || "",
                mapname: arg.MAPNAME || ""
            };
            if (arg.WF_ITEM_LOCATION) {
                argObj.wf_item_location = arg.WF_ITEM_LOCATION;
            }
            body.inboundarguments[arg.ARGNAME] = argObj;
        })
        return body;
    }



    const getPluginDetail = (val, currentNode, initialCall, updateSelectionListOnly, latestData = [], avoidLoading) => {
        setDetailsLoading(true);
        const pluginName = val?.slice(11);
        return dispatch(
            api.endpoints.getPluginDetail.initiate({
                account,
                pluginName: pluginName,
                workflow_group_name : leftTree.tree.body.selectedNode.workflowGroup,
                template_name: leftTree.tree.body.selectedNode.title,
                location: rightTree.currentTab,
                source: parentScreen,
                data: getBodyForPluginDetails(latestData)
            }, { forceRefetch: true }),
        ).then((response) => {
            if(response?.error){
                throw new Error(response?.error?.data?.message || t('ERR_PLUGIN_DESC'))
            }
            if (response?.data) {
                setPluginDescription(response?.data?.Description);
                setInValues(response?.data?.InValues);
                const inArray = createInArgs('IN', response?.data?.InValues, latestData, initialCall, updateSelectionListOnly);
                const outArray = createOutArgs('OUT', response?.data?.OutValues);
                if (initialCall) {
                    if (inArray.length) {
                        getNodeValues(currTab === 0 ? inArray?.[0] : outArray?.[0], true)
                        setCurrentNode(currTab === 0 ? inArray?.[0] : outArray?.[0], true);
                        updateSelectionList(inArray?.[0]?.selectionList || []);
                        setSelectedKeys({in: ["in-0"], out: ["out-0"]})
                    }else {
                        setCurrentNode(null);
                        setFieldType(t("SELECT"))
                    }
                }
                if (!updateSelectionListOnly) {
                    debounceChangeHandler(null, null, {
                        IN_ARG: inArray,
                        OUT_ARG: outArray,
                        CLASS: val
                    }, null, avoidLoading);
                }
            }
            return response?.data;
        }).catch((error) => {
            console.error(t('ERR_PLUGIN_DESC'), error);
            setPluginDescription('')
        })
        .finally(() => {
            setDetailsLoading(false);
        })
    };

    useEffect(() => {
        if (selectedNode) {
            setPlugin(selectedNode?.CLASS);
            setPluginName(selectedNode?.NAME || "UNNAMED");
            dataConversion("in", selectedNode?.IN_ARG || [], true);
            dataConversion("out", selectedNode?.OUT_ARG || []);
            setSelectedKeys({ in: ['in-0'], out: ['out-0'] })
            if (templateChanged && selectedNode?.CLASS) {
                setDetailsLoading(true);
                dispatch(
                treeActions.setLeftTreeContextActionValue({
                  screen: parentScreen,
                  data: { 
                    name: leftTree.tree.body.selectedNode.title, 
                    workflowGroup: leftTree.tree.body.selectedNode.workflowGroup,
                    source: parentScreen === "outbound" ? "PLUGIN" : "PLUGIN_WORKFLOW"
                  },
                  
                }))
            }else {
                getPluginDetail(selectedNode?.CLASS,null, true, selectedNode?.IN_ARG?.length ? true : false, selectedNode?.IN_ARG, true);
            }
            setDoNotLog(selectedNode?.LOG_WFITEM_DETAILS === "TRUE" ? false : true);
            setConcurrent(selectedNode?.CONCURRENT === "TRUE" || false);
            setDisableWFItem(selectedNode?.ENABLED === "TRUE" ? false : true);
        }
        setFieldTypeOptions(fieldTypeOptionsArray);
        setConvertCaseOptions(convertCaseOptionsArray);
        setPaddingDirectionOptions(paddingDirectionArray);
        setErrorOptions(errorArray);
    }, [selectedNode.key]);

    useEffect(() => {
        if (templateChangedSource === "PLUGIN") {
            getPluginDetail(selectedNode?.CLASS,null, true, selectedNode?.IN_ARG?.length ? true : false, selectedNode?.IN_ARG, true);
            dispatch(treeActions.setTemplateChangedSource({ screen: "outbound", data: null }));
        }
        else if (templateChangedSource === "PLUGIN_WORKFLOW") {
            getPluginDetail(selectedNode?.CLASS,null, true, selectedNode?.IN_ARG?.length ? true : false, selectedNode?.IN_ARG, true);
            dispatch(treeActions.setTemplateChangedSource({ screen: "workflow", data: null }));
        }
    }, [templateChangedSource])

    useEffect(() => {
        getPluginList();
        return () => {
            setCurrTab(0);
            setSelectedKeys({in: [], out: []});
            setCurrentNode({});
        }
    }, [selectedNode?.key])

    useEffect(() => {
        const newFieldOptions = fieldTypeOptions
            ? [
                ...fieldTypeOptions?.slice(0, 2),
                { value: "CONSTANT", text: t("CONSTANT") },
                ...fieldTypeOptions?.slice(2),
            ]
            : [];
        const fieldTypeDropDownItems = newFieldOptions.map((obj, key) => (
            <MenuItem key={key} value={obj.value}>
                {t(obj.text)}
            </MenuItem>
        ));
        setFieldTypeDropDownItems(fieldTypeDropDownItems);
    }, [fieldTypeOptions]);

    useEffect(() => {
        const options = convertCaseOptions?.map((obj, key) => {
            return <MenuItem key={key} value={obj.value}>
                {t(obj.text)}
            </MenuItem>
        });
        setConvertCaseDropdown(options)
    }, [convertCaseOptions]);

    useEffect(() => {
        const options = paddingDirectionOptions?.map((obj, key) => {
            return <MenuItem key={key} value={obj.value}>
                {obj.text}
            </MenuItem>
        });
        setPaddingDirectionDropdown(options);
    }, [paddingDirectionOptions]);

    useEffect(() => {
        const options = errorOptions?.map((obj, key) => {
            return <MenuItem key={key} value={obj.value}>
                {obj.text}
            </MenuItem>
        });
        setErrorDropdown(options);
    }, [errorOptions]);

    useEffect(() => {
        setValid(true);
        setDpNetworkCallMessage("");
    }, [datePatternModal, inboundDatePatternModal, numberFormatterModal])

    useEffect(() => {
        if(currentNode) getNodeValues(currentNode);
    }, [currentNode?.key, currentNode?.FIELDTYPE])

    // Maintain scroll position when InValues tree selection changes
    useEffect(() => {
        if (currTab === 0 && selectedKeys.in?.length > 0 && treeContainerRef.current && treeData.in?.length > 0 && !detailLoading) {
            // Use a longer timeout to ensure all re-renders are complete
            const timeoutId = setTimeout(() => {
                if (treeContainerRef.current) {
                    scrollToSelectedItem(selectedKeys.in, treeContainerRef);
                }
            }, 200);
            
            return () => clearTimeout(timeoutId);
        }
    }, [selectedKeys.in, currTab, treeData.in, detailLoading])

    return (
        <>
            <Stack spacing={"10px"} padding={'12px'} className="tp-segment">
                <FormControl size="small">
                    <TextField
                        variant="outlined"
                        size="small"
                        label={t("LBL_PLUGIN_NAME")}
                        className={"width-100"}
                        value={pluginName || ''}
                        onBlur={(e) => handleNameBlur(e.target.value)}
                        onFocus={() => dispatch(treeActions.setIsInputFocusedTrue())}
                        onChange={(e) => {
                            const { value } = e.target;
                            setPluginName(value);
                            if (parentScreen !== "workflow" && value) {
                                debounceChangeHandler("NAME", value);
                            }
                        }}
                        InputProps={{
                           ...( parentScreen === "workflow" && { endAdornment: (
                                <InputAdornment position="end">
                                    <div style={styles.getDataNameAdornment}>{`ID: ${wfItemId}`}</div>
                                </InputAdornment>
                            )}),
                        }}
                    />
                {
                    parentScreen === "workflow" &&
                    <Box
                    variant='outlined'
                    sx={{ display: "flex", flexWrap: "wrap", my: 1 }}
                    className='width-100'
                    size='small'
                    >
                        <LabeledCheckbox
                            label={t("LBL_LOG_NO_WFITEM_DETAILS")}
                            handleCheck={(checked) => {
                                setDoNotLog(checked);
                                debounceChangeHandler(
                                    "LOG_WFITEM_DETAILS",
                                    checked ? "FALSE" : "TRUE"
                                );
                            }}
                            checked={doNotLog}
                        />
                        <LabeledCheckbox
                            label={t("LBL_RUN_CONCURRENTLY")}
                            handleCheck={(checked) => {
                                setConcurrent(checked);
                                debounceChangeHandler(
                                    "CONCURRENT",
                                    checked ? "TRUE" : "FALSE"
                                );
                            }}
                            checked={concurrent}
                        />
                        <LabeledCheckbox
                            label={t("LBL_DISABLE_WFITEM")}
                            handleCheck={(checked) => {
                                setDisableWFItem(checked);
                                debounceChangeHandler(
                                    "ENABLED",
                                    checked ? "FALSE" : "TRUE"
                                );
                            }}
                            checked={disableWFItem}
                        />
                    </Box>
                }
                </FormControl>
                <FormControl variant="outlined" className="width-100" size="small">
                    <InputLabel id="pluginLabel">{t("LBL_JAVA_PLUGIN_CLASS")}</InputLabel>
                    <Select
                        className={"width-100"}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                        name={'JAVACLASSPLUGIN'}
                        value={pluginsDropdown?.length ? plugin : ''}
                        labelId="pluginLabel"
                        label={t("LBL_JAVA_PLUGIN_CLASS")}
                        id="pluginDropdown"
                        disabled={loading}
                        endAdornment={
                            loading ? (
                                <InputAdornment position='end'>
                                    <CircularProgress size={20} sx={{ marginRight:'10px'}} />
                                </InputAdornment>
                            ) : (
                                ''
                            )
                        }
                        displayEmpty
                        onChange={(e) => {
                            setPlugin(e.target.value);
                            submitChange(null, null, {'CLASS': e.target.value, IN_ARG: [], OUT_ARG: []}, () => {
                                getPluginDetail(e.target.value, null, true, false, []);
                            });

                        }}>
                        {pluginsDropdown}
                    </Select>
                </FormControl>
                <p ref={errorRef} className='error'></p>
                {plugin && <Typography
                    sx={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => setPluginModal(true)}
                    variant="body1">
                    {t('LBL_SHOW_DESCRIPTION')}
                </Typography>}
                <div className='div-textbox' style={{ height: 'auto' }}>
                    <Box height={'100%'}>
                        <Box className='divider-bottom flex align-center'>
                            <Tabs value={currTab} onChange={handleTabChange} className='flex align-center'>
                                <Tab
                                    label={
                                        <div className="flex align-center margin-right-4">
                                            {t('TAB_IN_VALUES')}
                                        </div>
                                    }
                                />
                                <Tab
                                    label={
                                        <div className="flex align-center margin-right-4">
                                            {t("TAB_OUT_VALUES")}
                                        </div>
                                    }
                                />
                            </Tabs>
                        </Box>
                        <Box className="height-100-tab overflow-auto" sx={{ height: '25vh', overflowY: 'auto' }} ref={treeContainerRef}>
                            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
                                {!detailLoading ?
                                    <Tree
                                        onExpand={(keys) => onExpand('in', keys)}
                                        onSelect={(keys, detail) => onSelect('in', keys, detail)}
                                        treeData={treeData.in}
                                        icon={Icon}
                                        titleRender={titleRender}
                                        selectedKeys={selectedKeys.in}
                                        expandedKeys={expandedKeys.in}
                                        showIcon
                                        selectable={true}
                                    /> : <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "20vh"}}>        
                                        <CircularProgress />
                                    </div>
                                }
                            </TabPanel>
                            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
                                {!detailLoading ?
                                    <Tree
                                        onExpand={(keys, detail) => onExpand('out', keys, detail)}
                                        onSelect={(keys, detail) => onSelect('out', keys, detail)}
                                        treeData={treeData.out}
                                        icon={Icon}
                                        selectedKeys={selectedKeys.out}
                                        expandedKeys={expandedKeys.out}
                                        showIcon
                                        selectable={true}
                                    /> : <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "20vh"}}>        
                                        <CircularProgress />
                                    </div>
                                }
                            </TabPanel>
                        </Box>
                    </Box>
                </div>
                {plugin && <>
                    {currTab === 0 && currentNode !== null && plugin !== '' && plugin !== undefined && <FormControl variant="outlined" className="width-100" size="small">
                        <InputLabel id="ftDropdownLabel">{t("LBL_FLD_TYPE")}</InputLabel>
                        <Select
                            disabled={detailLoading}
                            className={"width-100"}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name={"FIELDTYPE"}
                            value={fieldType || ''}
                            labelId="ftDropdownLabel"
                            label={t("LBL_FLD_TYPE")}
                            id="ftDropdown"
                            onChange={(e) => {
                                const value = e.target.value;
                                setFieldType(value);
                                handleCurrentNodeChange(null, null , {
                                        FIELDTYPE: value,
                                        VALUE: value === "CONSTANT" ? constantValueOptions[0] : null,
                                        ...(value === "CONSTANT" ?  { FIELDTYPE: "PROPERTY"} :
                                        value === "ALPHA" ? {FILLCHAR: " ", PADDIR: "RIGHT", LENGTH: 0, CONVERT_CASE: null, RECORD_TYPE: parentScreen === "workflow" ? "SYSTEM_DATA" : null} :
                                        value === "BIT_FLAG" ? {LENGTH: 0, KEEP_ORIG_DATA_ON_ERROR: "TRUE", DEFAULT_VALUE: null} :
                                        value === "DATE" ? {FILLCHAR: " ", PADDIR: "RIGHT", LENGTH: 0, KEEP_ORIG_DATA_ON_ERROR: "TRUE", DEFAULT_VALUE: null, RECORD_TYPE: parentScreen === "workflow" ? "SYSTEM_DATA" : null, PATTERN: null} :
                                        value === "FLOAT" ? {FILLCHAR: " ", PADDIR: "RIGHT", LENGTH: 0, PRECISION: 0, KEEP_ORIG_DATA_ON_ERROR: "TRUE", DEFAULT_VALUE: null, RECORD_TYPE: parentScreen === "workflow" ? "SYSTEM_DATA" : null, PATTERN: null} :
                                        value === "INTEGER" ? {FILLCHAR: " ", PADDIR: "RIGHT", LENGTH: 0, PRECISION: 0, PRECISION_OUT: 0, KEEP_ORIG_DATA_ON_ERROR: "TRUE", DEFAULT_VALUE: null, RECORD_TYPE: parentScreen === "workflow" ? "SYSTEM_DATA" : null, PATTERN: null} : {}
                                    )
                                });
                            }}>
                            {fieldTypeDropDownItems}
                        </Select>
                    </FormControl>}
                    {currTab === 0 && currentNode !== null && fieldType !== 'PACKED_INT' && fieldType !== 'ZONED_INT' && <>
                            {!["SELECT",'PROPERTY', "CONSTANT"].includes(fieldType)
                            && !(parentScreen === "workflow" && fieldType === "BIT_FLAG") 
                            && <Accordion defaultExpanded sx={styles.accordianContainer}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls='accordianFormattingOptions'
                                    id='dataSource'
                                    className='accordian-override'
                                    sx={styles.accordianHeader}
                                >
                                    <SectionHeader text={`${t("LBL_DATA_SOURCE")}`} />
                                </AccordionSummary>
                                <AccordionDetails sx={styles.accordianContent}>
                                    <Stack spacing={"10px"}>
                                            {parentScreen !== "workflow" ? <SourceType
                                                node={{
                                                    PARENT: currentNode?.PARENT,
                                                    MAPNAME: currentNode?.MAPNAME,
                                                    RECORD_TYPE: currentNode?.RECORD_TYPE,
                                                    ACTION: currentNode?.ACTION,
                                                    INDEX: currentNode?.INDEX,
                                                    CUSTOM_DB_FIELD: currentNode?.CUSTOM_DB_FIELD,
                                                    PLUGIN_NAME: currentNode?.PLUGIN_NAME,
                                                    key: currentNode?.key,
                                                }}
                                                initialSelectCall={true}
                                                valuesHandler={mapping1Handler}
                                                rerenderSourceType={currentNode?.RECORD_TYPE}
                                                disabled={detailLoading}
                                            />
                                        : <WorkflowSourceType
                                            node={{
                                                key: currentNode?.key,
                                                RECORD_TYPE: currentNode?.RECORD_TYPE,
                                                WFITEM: currentNode?.WF_ITEM_LOCATION,
                                                WF_ITEM_ID: currentNode?.WF_ITEM_ID,
                                                WF_ITEM_LOCATION: currentNode?.WF_ITEM_LOCATION,
                                                OUTBOUND_NAME: currentNode?.OUTBOUND,
                                                MAPNAME: currentNode?.MAPNAME,
                                                WF_ITEM_DEPENDENCY_TIMEOUT:
                                                currentNode?.WF_ITEM_DEPENDENCY_TIMEOUT,
                                                CALL_WORKFLOW: currentNode?.CALL_WORKFLOW,
										        CALL_WORKFLOW_ACCOUNT: currentNode?.CALL_WORKFLOW_ACCOUNT,
										        CALL_WORKFLOW_GROUP: currentNode?.CALL_WORKFLOW_GROUP,
                                            }}
                                            valuesHandler={mapping1Handler}
                                            disabled={detailLoading}
                                        />}
                                    </Stack>
                                </AccordionDetails>
                            </Accordion>}
                            {!["SELECT", 'PROPERTY', "CONSTANT"].includes(fieldType) 
                            && !(parentScreen === "workflow" && fieldType === "BIT_FLAG") 
                            && <Accordion sx={styles.accordianContainer} defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls='accordianFormattingOptions'
                                    id='formattingOptions'
                                    className='accordian-override'
                                    sx={styles.accordianHeader}
                                >
                                    <SectionHeader text={t("LBL_FORMATE_OPTIONS")} />
                                </AccordionSummary>
                                <AccordionDetails sx={styles.accordianContent}>
                                    <Stack spacing={"10px"}>    
                                        {fieldType === 'DATE' && <FormControl className="width-100" size="small">
                                            {parentScreen !== "workflow" && 
                                            <>
                                            <div className="flex">
                                                <TextField  
                                                    variant="outlined"
                                                    size="small"
                                                    label={t("LBL_INBOUND_DATE_PATTERN")}
                                                    className={"width-100"}
                                                    value={inboundDate || ''}
                                                    error={!valid}
                                                    disabled={isDateMapped || detailLoading}
                                                    onChange={(e) => {
                                                        setInboundDate(e.target.value);
                                                        setInboundDatePattern(e.target.value);
                                                        handleCurrentNodeChange('INBOUND_PATTERN', e.target.value);
                                                        setDpNetworkCallMessage('');
                                                        setFlag(false)
                                                        setValid(true)
                                                    }}
                                                />
                                                <Button
                                                    disabled={isDateMapped || detailLoading}
                                                    variant="outlined"
                                                    size="small"
                                                    disableElevation
                                                    className="margin-left-4"
                                                    sx={{
                                                        width: "40px",
                                                        padding: "4px 8px",
                                                        minWidth: "40px",
                                                    }}
                                                    onClick={() => setInboundDatePatternModal(true)}>
                                                    <CalendarMonthOutlinedIcon fontSize="small"></CalendarMonthOutlinedIcon>
                                                </Button>
                                            </div>
                                            <div style={{ display: 'inline-block' }}>
                                                <p style={{ fontSize: '12px', margin: '10px' }}>{dpNetworkCallMessage}</p>
                                            </div>
                                            </>
                                            }
                                            </FormControl>}
                                            {(fieldType !== 'ALPHA' && fieldType !== 'BIT_FLAG' && !['PROPERTY', "CONSTANT"].includes(fieldType)) &&
                                                <FormControl className="width-100" size="small">
                                                    <div className="flex">
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            label={t("LBL_PATTERN")}
                                                            className={"width-100"}
                                                            value={date || ''}
                                                            error={!valid}
                                                            onChange={(e) => {
                                                                setDate(e.target.value);
                                                                setDatePattern(e.target.value)
                                                                handleCurrentNodeChange('PATTERN', e.target.value)
                                                                setDpNetworkCallMessage('');
                                                                setFlag(false)
                                                                setValid(true)
                                                            }}
                                                            disabled={detailLoading}
                                                        />
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            disableElevation
                                                            className="margin-left-4"
                                                            disabled={detailLoading}
                                                            sx={{
                                                                width: "40px",
                                                                padding: "4px 8px",
                                                                minWidth: "40px",
                                                            }}
                                                            onClick={() => {
                                                                if (fieldType === 'DATE') {
                                                                    setDatePatternModal(true);
                                                                } else if (['INTEGER', 'FLOAT'].includes(fieldType)) {
                                                                    setNumberFormatterModal(true);
                                                                }
                                                            }}>
                                                            {['INTEGER', 'FLOAT'].includes(fieldType) ? 
                                                                <MoreHorizIcon fontSize="small" /> :
                                                                <CalendarMonthOutlinedIcon fontSize="small" />
                                                            }
                                                        </Button>
                                                    </div>
                                                    <div style={{ display: 'inline-block' }}>
                                                        <p style={{ fontSize: '12px', margin: '10px' }}>{dpNetworkCallMessage}</p>
                                                    </div>
                                                </FormControl>}
                                            {fieldType === 'ALPHA' && <FormControl variant="outlined" className="width-100" size="small">
                                                <InputLabel id="convertCaseLabel">{t("LBL_CONVERT_CASE")}</InputLabel>
                                                <Select
                                                    disabled={detailLoading}
                                                    className={"width-100"}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            sx: {
                                                                maxHeight: 300,
                                                            },
                                                        },
                                                    }}
                                                    name={'CONVERTCASE'}
                                                    value={convertCase || 'DO_NOT_CONVERT'}
                                                    labelId="convertCaseLabel"
                                                    label={t("LBL_CONVERT_CASE")}
                                                    id="convertCaseDropdown"
                                                    onChange={(e) => {
                                                        setConverCase(e.target.value);
                                                        handleCurrentNodeChange('CONVERT_CASE', e.target.value === "DO_NOT_CONVERT" ? null : e.target.value);
                                                    }}>
                                                    {convertCaseDropdown}
                                                </Select>
                                            </FormControl>}
                                            {(fieldType !== 'BIT_FLAG' && !['PROPERTY', "CONSTANT"].includes(fieldType)) &&
                                            !(["INTEGER","FLOAT"].includes(fieldType) && parentScreen === "workflow") &&
                                                <>
                                                    <FormControl variant="outlined" className="width-100" size="small">
                                                        <InputLabel id="paddingDirectionLabel">{t("LBL_PADDING_DIRECTION")}</InputLabel>
                                                        <Select
                                                            className={"width-100"}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        maxHeight: 300,
                                                                    },
                                                                },
                                                            }}
                                                            disabled={detailLoading}
                                                            name={'PADDINGDIRECTION'}
                                                            value={paddingDirection || ''}
                                                            labelId="paddingDirectionLabel"
                                                            label={t("LBL_PADDING_DIRECTION")}
                                                            id="paddingDirectionDropdown"
                                                            onChange={(e) => {
                                                                setPaddingDirection(e.target.value);
                                                                handleCurrentNodeChange('PADDIR', e.target.value)
                                                            }}>
                                                            {paddingDirectionDropdown}
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl size="small">
                                                        <TextField
                                                            disabled={detailLoading}
                                                            variant="outlined"
                                                            size="small"
                                                            label={t("LBL_FILL_CHAR")}
                                                            className={"width-100"}
                                                            name={"FILLCHARACTER"}
                                                            value={(fillCharacter || '')}
                                                            onChange={(e) => {
                                                                setFillCharacter(e.target.value);
                                                                handleCurrentNodeChange('FILLCHAR', e.target.value === "SPACE" ? " " : e.target.value)
                                                            }}
                                                        />
                                                    </FormControl>
                                                </>
                                            }
                                            
                                            { !(parentScreen === "workflow" && ["INTEGER","FLOAT"].includes(fieldType)) && 
                                            <FormControl size="small">
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    label={t("LBL_LENGTH")}
                                                    className={"width-100"}
                                                    name={"LENGTH"}
                                                    disabled={fieldType === 'PROPERTY' || detailLoading}
                                                    value={length}
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        const newValue = value.substring(0, 9).replaceAll(/\D/g, "");;
                                                        setLength(newValue);
                                                        handleCurrentNodeChange('LENGTH', newValue)
                                                    }}
                                                />
                                            </FormControl>}
                                            {!(parentScreen === "workflow" && fieldType === 'INTEGER') &&
                                            (fieldType === 'FLOAT' || fieldType === 'INTEGER') && <FormControl size="small">
                                                <TextField
                                                    disabled={detailLoading}
                                                    variant="outlined"
                                                    size="small"
                                                    label={parentScreen === "workflow" ? t("PRECISION") : t("LBL_PRECISION_IN")}
                                                    className={"width-100"}
                                                    name={"INPRECISION"}
                                                    value={inboundPrecision}
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        const newValue = value.substring(0, 9).replaceAll(/\D/g, "");;
                                                        setInboundPrecision(newValue);
                                                        handleCurrentNodeChange('PRECISION', newValue)
                                                    }}
                                                />
                                            </FormControl>}
                                            {!(parentScreen === "workflow" && fieldType === 'INTEGER') &&
                                            fieldType === 'INTEGER' && <FormControl size="small">
                                                <TextField
                                                    disabled={detailLoading}
                                                    variant="outlined"
                                                    size="small"
                                                    label={t("LBL_PRECISION_OUT")}
                                                    className={"width-100"}
                                                    name={"OUTPRECISION"}
                                                    value={outboundPrecision || 0}
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        const newValue = value.substring(0, 9).replaceAll(/\D/g, "");;
                                                        setOutboundPrecision(newValue);
                                                        handleCurrentNodeChange('PRECISION_OUT', newValue)
                                                    }}
                                                />
                                            </FormControl>}

                                            {(fieldType !== 'ALPHA' && !['PROPERTY', "CONSTANT"].includes(fieldType)) &&
                                                <>
                                                    <FormControl variant="outlined" className="width-100" size="small">
                                                        <InputLabel id="onErrorLabel">{t("LBL_ON_ERR")}</InputLabel>
                                                        <Select
                                                            disabled={detailLoading}
                                                            className={"width-100"}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        maxHeight: 300,
                                                                    },
                                                                },
                                                            }}
                                                            name={'ERRORLBL'}
                                                            value={error || 'FALSE'}
                                                            labelId="onErrorLabel"
                                                            label={t("LBL_ON_ERR")}
                                                            id="errorDropdown"
                                                            onChange={(e) => {
                                                                setError(e.target.value);
                                                                handleCurrentNodeChange('KEEP_ORIG_DATA_ON_ERROR', e.target.value === "TRUE" ? "TRUE" : null)
                                                            }}>
                                                            {onErrorDropDownMenu}
                                                        </Select>
                                                    </FormControl>
                                                    {error !== 'TRUE' && <FormControl size="small">
                                                        <TextField
                                                            disabled={detailLoading}
                                                            variant="outlined"
                                                            size="small"
                                                            label={t("LBL_DEFAULT_VALUE")}
                                                            className={"width-100"}
                                                            name={"DEFAULTVALUE"}
                                                            value={defaultValue || ''}
                                                            onChange={(e) => {
                                                                setDefaultValue(e.target.value);
                                                                handleCurrentNodeChange('DEFAULT_VALUE', e.target.value)
                                                            }}
                                                        />
                                                    </FormControl>}
                                                </>
                                            }

                                            {parentScreen === "workflow" && Object.keys(hideControlsArray).includes(currentNode?.FIELDTYPE) 
                                            && <FormattingOptionsCheckboxes
                                                disabled={detailLoading}
                                                node={currentNode}
                                                valuesHandler={handleCurrentNodeChange}
                                                hideControls={hideControlsArray[currentNode?.FIELDTYPE]}
                                            />}
                                    </Stack>
                                </AccordionDetails>
                            </Accordion>}
                            {['PROPERTY', "CONSTANT"].includes(fieldType) &&
                                    <>
                                        { currentNode?.ARGNAME === "Execute Date (yyyy/mm/dd)" ? <StandaloneDatePicker
                                            onChangeHandler={(value) => {
                                                setConstant(value);
                                                setLength('');
                                                handleCurrentNodeChange(null, null, {VALUE: value, LENGTH: ""});
                                            }}
                                            value={constant || ''}
                                            
                                        /> : <ConstantValueControl 
                                            disabled={detailLoading}
                                            onBlur={(value) => {
                                                (parentScreen === "workflow") && dispatch(treeActions.setTemplateChanged({ screen: parentScreen, data: true }));
                                                handleCurrentNodeChange(null, null, {VALUE: value, LENGTH: value !== ' ' ? value?.length * repeat : "0"}, false);
                                            }}
                                            constantValue={constant || ''} 
                                            setConstantValue={(value, userSelectedValue) => {
                                                if (value === constant) return;
                                                if(currentNode.ARGNAME === "Execute Time (24 hour hh:mm)") {
                                                    const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
                                                    if(regex.test(value)) {
                                                        handleCurrentNodeChange(null, null, {VALUE: value, LENGTH: value !== ' ' ? value?.length * repeat : "0"}, true);
                                                        setConstantError("");
                                                    }else {
                                                        setConstantError(t("BOX_INVALID_TM_USE_24_TM_FORMAT"));
                                                    }
                                                }else {
                                                    setConstant(value);
                                                    setLength(value !== ' ' ? value?.length * repeat : '');
                                                    if (userSelectedValue) {
                                                        handleCurrentNodeChange(null, null, {VALUE: value, LENGTH: value !== ' ' ? value?.length * repeat : "0"}, true);
                                                    }else {
                                                        debounceCurrentNodeChangeHandler(null, null, {VALUE: value, LENGTH: value !== ' ' ? value?.length * repeat : "0"});
    
                                                    }
                                                }
                                            }} 
                                            constantValueOptions={constantValueOptions?.length > 0 ? constantValueOptions : []} 
                                        />}
                                        {constantError ? <span className='error'>{constantError}</span> : ""}
                                        <FormControl size="small">
                                            <TextField
                                                disabled={detailLoading}
                                                variant="outlined"
                                                size="small"
                                                label={t("LBL_REPEAT_#_TIMES")}
                                                className={"width-100"}
                                                name={"REPEAT"}
                                                value={repeat || ''}
                                                onBlur={() => {
                                                    setRepeat(repeat || 1)
                                                }}
                                                onChange={(e) => {
                                                    const { value } = e.target;
                                                    const newValue = value.substring(0, 9).replaceAll(/\D/g, "");
                                                    setRepeat(newValue);
                                                    if (fieldType === 'PROPERTY' || fieldType === "CONSTANT") setLength((constant || "")?.length * value)
                                                    handleCurrentNodeChange("REPEAT", newValue, {REPEAT: value, LENGTH: constant !== ' ' ? (constant || "")?.length * value : "0"});
                                                }}
                                            />
                                        </FormControl>
                                        {parentScreen !== "workflow" && <FormControl size="small">
                                            <TextField
                                            
                                                variant="outlined"
                                                size="small"
                                                label={t("LBL_LENGTH")}
                                                className={"width-100"}
                                                name={"LENGTH"}
                                                disabled={['PROPERTY', "CONSTANT"].includes(fieldType) || detailLoading}
                                                value={length}
                                                onChange={(e) => {
                                                    const { value } = e.target;
                                                    const newValue = value.substring(0, 9).replaceAll(/\D/g, "");;
                                                    setLength(newValue);
                                                    handleCurrentNodeChange('LENGTH', newValue)
                                                }}
                                            />
                                        </FormControl>}
                                    </>
                                }
                            </>}
                            {(currentNode !== null && parentScreen !== "workflow" && !["SELECT", 'PACKED_INT', "ZONED_INT"].includes(fieldType) && currTab === 0 ) && <div>
                                <TPCheckbox
                                    disabled={detailLoading}
                                    label={t('IGNORE_GLOBAL_SUB')}
                                    checked={ignoreSubs}
                                    handleCheck={(checked) => {
                                        setIgnoreSubs(checked);
                                        handleCurrentNodeChange('IGNORE_GLOBAL_SUB', checked ? "TRUE" : "FALSE");
                                    }} 
                                />
                            </div>}
                </>}
                
                {parentScreen === "workflow" && Object.keys(hideControlsArray).includes(fieldType) && currTab === 0 && <AdvancedProperties
                    disabled={detailLoading}
                  selectedNode={currentNode}
                  updatedSelectedNodeWithAdvanceProperties={advancePropertiesHandler}
                />}

                {(parentScreen === "workflow" && fieldType === "BIT_FLAG" && currTab === 0) && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "15px",
                            marginTop: "15px",
                        }}
                    >
                        <FormControl variant="outlined" className="width-100" size="small">
                            <InputLabel>{t("LBL_BIT_POSITION")}</InputLabel>
                            <Select
                                disabled={detailLoading}
                                variant="outlined"
                                size="small"
                                className={"width-100"}
                                value={bitPosition}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setBitPosition(value);
                                    handleCurrentNodeChange("BIT_POSITION", value);
                                }}
                            >
                                {bitPositionDropdown}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className="width-100" size="small">
                            <InputLabel>{t("LBL_BIT_VALUE")}</InputLabel>
                            <Select
                                disabled={detailLoading}
                                variant="outlined"
                                size="small"
                                className={"width-100"}
                                value={bitValue}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setBitValue(value);
                                    handleCurrentNodeChange("VALUE", value);
                                }}
                            >
                                {bitValueDropdown}
                            </Select>
                        </FormControl>
                    </div>
                )}
            </Stack>
            <DatePattern
                disabled={detailLoading}
                openModal={inboundDatePatternModal}
                docPath={docPaths.DATE}
                okHandler={inboundDatePatternModalOkHandler}
                cancelHandler={dateInboundPatternModalCancelHandler}
                onChangeHandler={setInboundDatePattern}
                testDateHandler={testDateHandler}
                dpNetworkCallMessage={dpNetworkCallMessage}
                datePattern={inboundDatePattern}
                valid={valid}
            />
            <DatePattern
            disabled={detailLoading}
                openModal={datePatternModal}
                docPath={docPaths.DATE}
                okHandler={datePatternModalOkHandler}
                cancelHandler={datePatternModalCancelHandler}
                onChangeHandler={setDatePattern}
                testDateHandler={testDateHandler}
                dpNetworkCallMessage={dpNetworkCallMessage}
                datePattern={datePattern}
                valid={valid}
            />
            <NumberFormatter
                disabled={detailLoading}
                openModal={numberFormatterModal}
                docPath={docPaths.NumberFormatter}
                cancelHandler={setNumberFormatterModal}
                okHandler={numberFormatterOkHandler}
                fieldValue={numberPattern}
                precision={inboundPrecision}
                roundInit={currentNode?.ROUND}
                setNumberFormatterModal={setNumberFormatterModal}
            />
            {pluginModal && <PluginModal
                disabled={detailLoading}
                openModal={pluginModal}
                closeModal={() => setPluginModal(false)}
                pluginHeader={plugin}
                pluginDescription={pluginDescription}
            />}
            {openDelimiterDialog && <ReplacementModal
                disabled={detailLoading}
                openModal={openDelimiterDialog}
                closeModal={handleDelimiterDialog}
                inputValue={constant === '-- Select --' ? '' : constant}
                handleValue={handleDelimiterDialogValue}
                plugin={true}
            />}
            
            {/* Error Modal for name validation - only for workflow */}
            {parentScreen === "workflow" && (
                <ErrorModal
                    errorModal={nameErrorModal}
                    setErrorModal={setNameErrorModal}
                    errorMessage={nameErrorMessage}
                    errorType={t('ERROR')}
                    handleErrorModal={handleNameErrorModal}
                />
            )}
        </>
    )
}

export default PluginProperties

export const PluginModal = ({ openModal, closeModal, pluginHeader, pluginDescription }) => {
    const {t} = useTranslation()
    const renderDescription = (description) => {
        if(!description) return;
        // Split the description by '\n\n'
        const parts = description.split('\n\n');
        return `<div>
                ${parts.map((part) => `<div>
                    <div>
                        ${part.split('\n').map((line) => `<p>${line}</p>`).join("")}
                        <br/>
                    </div>
                    </div>`
                ).join("")}
            </div>`
        
    };

    return <>
        <Dialog
            fullWidth
            open={openModal}
            onClose={closeModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className='dialog-header'>
                <div className="title">{pluginHeader}</div>
            </DialogTitle>

            <DialogContent dividers sx={{ height: '40vh', overflowY: 'auto' }}>
                <div dangerouslySetInnerHTML={{ __html: pluginDescription ? renderDescription(pluginDescription) : t("ERR_PLUGIN_DESC") }}></div>
            </DialogContent>

            <DialogActions>
                <Button
                    size="small"
                    onClick={closeModal}
                    variant={"outlined"}
                >
                    {t("BTN_CLOSE")}
                </Button>
            </DialogActions>
        </Dialog>
    </>
}

const supportedJSONValuesForFieldTypes = {
	CONSTANT: [
        "VALUE", 
        "REPEAT", 
        "IGNORE_GLOBAL_SUB",
        "UNIT",
        "LENGTH",
        "isDateMapped"
    ],
    PROPERTY: [
        "VALUE", 
        "REPEAT", 
        "IGNORE_GLOBAL_SUB",
        "LENGTH",
        "isDateMapped",
        "selectionList"
    ],
	BIT_FLAG: [
        "BIT_POSITION", 
        "VALUE",
        "DEFAULT_VALUE", 
        "MAPNAME",
        "LENGTH",
        "KEEP_ORIG_DATA_ON_ERROR",
        "IGNORE_GLOBAL_SUB",
        "RECORD_TYPE",
        "SOURCE_TYPE",
        "PARENT",
        "MAP_REPETITION_INDEX",
        "SOURCE_REPEATING_FIELD",
        "CUSTOM_DB_FIELD",
        "PLUGIN_NAME",
        "VARIABLE_COLLECTION_ACTION",
        "VARIABLE_COLLECTION_INDEX",
        "WF_ITEM_ID", 
		"WF_ITEM_LOCATION",
        "isDateMapped"
    ],
	DATE: [
		"INBOUND_PATTERN",
		"PATTERN",
		"FILLCHAR",
		"PADDIR",
		"LENGTH",
		"KEEP_ORIG_DATA_ON_ERROR",
		"DEFAULT_VALUE",
		"IGNORE_GLOBAL_SUB",
		"UNIT",
		"MAPNAME",
		"RECORD_TYPE",
		"SOURCE_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
		"SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
        "PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
        "WF_ITEM_ID", 
		"WF_ITEM_LOCATION",
        "TRIMDATA",
        "REPLACE",
        "MASK",
        "FUNCTION",
        "SUBSTRING",
        "isDateMapped"
	],
	ALPHA: [
		"CONVERT_CASE",
		"FILLCHAR",
		"PADDIR",
		"LENGTH",
		"IGNORE_GLOBAL_SUB",
		"MAPNAME",
		"SOURCE_TYPE",
		"RECORD_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
        "SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
        "PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
        "WF_ITEM_ID", 
		"WF_ITEM_LOCATION",
        "TRIMDATA",
        "RPT_TRUNC_ERR",
        "REPLACE",
        "MASK",
        "FUNCTION",
        "SUBSTRING",
        "isDateMapped"
	],
	INTEGER: [
        "LENGTH",
		"PATTERN",
		"PRECISION_OUT",
		"ROUND",
		"PRECISION",
        "PADDIR",
        "FILLCHAR",
		"KEEP_ORIG_DATA_ON_ERROR",
		"DEFAULT_VALUE",
		"IGNORE_GLOBAL_SUB",
		"UNIT",
		"MAPNAME",
		"SOURCE_TYPE",
		"RECORD_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
        "SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
        "PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
        "WF_ITEM_ID", 
		"WF_ITEM_LOCATION",
        "TRIMDATA",
        "REPLACE",
        "MASK",
        "FUNCTION",
        "SUBSTRING",
        "isDateMapped"
	],
	FLOAT: [
        "PATTERN",
		"ROUND",
		"PRECISION",
        "LENGTH",
        "PADDIR",
        "FILLCHAR",
		"KEEP_ORIG_DATA_ON_ERROR",
		"DEFAULT_VALUE",
		"IGNORE_GLOBAL_SUB",
		"MAPNAME",
		"SOURCE_TYPE",
		"RECORD_TYPE",
		"PARENT",
		"MAP_REPETITION_INDEX",
        "SOURCE_REPEATING_FIELD",
		"CUSTOM_DB_FIELD",
        "PLUGIN_NAME",
		"VARIABLE_COLLECTION_ACTION",
		"VARIABLE_COLLECTION_INDEX",
        "WF_ITEM_ID", 
		"WF_ITEM_LOCATION",
        "TRIMDATA",
        "ROUND",
        "REPLACE",
        "MASK",
        "FUNCTION",
        "SUBSTRING",
        "isDateMapped"
	],
	ZONED_INT: [],
	PACKED_INT: [],
};


const styles = {
	getDataNameAdornment: {
		color: "#666666",
		fontSize: "9px",
		position: "absolute",
		right: "13px",
		top: "-6px",
		backgroundColor: "#FFF",
		zIndex: "2",
		padding: "0 5px",
		height: "12px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	fpContainer: {
		// padding: "0 16px 16px 16px"
		padding: "0 4px 4px 4px",
	},
	accordianContainer: {
		border: "none",
		padding: "0",
		margin: "0",
		boxShadow: "none",
		backgroundColor: "unset",
	},
	accordianHeader: {
		border: "none",
		padding: "0",
		margin: "0",
		backgroundColor: "unset",
	},
	accordianContent: {
		border: "none",
		padding: "0 0px",
		margin: "0",
		backgroundColor: "unset",
	},
};

const hideControlsArray = {
    "ALPHA": ["IGNORE_GLOBAL_SUB", "ROUND", "URLENCODE"],
    "DATE": ["IGNORE_GLOBAL_SUB", "RPT_TRUNC_ERR", "ROUND", "URLENCODE"],
    "FLOAT": ["IGNORE_GLOBAL_SUB", "RPT_TRUNC_ERR", "URLENCODE"],
    "INTEGER": ["IGNORE_GLOBAL_SUB", "RPT_TRUNC_ERR", "ROUND", "URLENCODE"],
}